import axios from 'axios'

const URL = 'api/configuracao'
class ParametrosSistemaApiClient {
	async buscarTodosParametros() {
		return await axios.get(`${URL}/parametrosSistema`)
	}
}

export default new ParametrosSistemaApiClient()
